import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { NavigationLink } from 'components';
import classes from './index.module.css';
import { RouteConstants } from 'constants/index';

const { ROUTE_HOME, ROUTE_ABOUT_US, ROUTE_FAQ, ROUTE_CREDIT_CARD, ROUTE_MOBILE_APP } = RouteConstants;

interface INavigation {
  onNavigate?: any;
}

const Navigation = ({
  onNavigate
}: INavigation) => {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');

    if (contactSection) {
      const yOffset = -120;
      const y = contactSection.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });

      if (onNavigate) onNavigate();
    } else {
      sessionStorage.setItem('scrollToContact', 'true');
      window.location.href = ROUTE_HOME;
    }
  };

  return (
    <Flex className={classes.wrapper}>
      <NavigationLink
        path={ROUTE_HOME}
        label={t('navigation.home')}
        onNavigate={onNavigate}
      />
      <NavigationLink
        path={ROUTE_ABOUT_US}
        label={t('navigation.about')}
        onNavigate={onNavigate}
      />
      <NavigationLink
        path={ROUTE_HOME}
        label={t('navigation.contact')}
        onNavigate={onNavigate}
        onClick={scrollToContact}
      />
      <NavigationLink
        path={ROUTE_FAQ}
        label={t('navigation.faq')}
        onNavigate={onNavigate}
      />
      <NavigationLink
        path={ROUTE_CREDIT_CARD}
        label={t('navigation.credit_card')}
        onNavigate={onNavigate}
      />
      <NavigationLink
        path={ROUTE_MOBILE_APP}
        label={t('navigation.mobile_app')}
        highlight={true}
        onNavigate={onNavigate}
      />
    </Flex>
  );
}

export default Navigation;